import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IInvoiceOutward } from 'app/modules/admin/transactions/invoices/invoices.types';
import { IOutwardInward } from '../outward-inward/outward-inward.types';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InwardsService } from 'app/modules/admin/transactions/inwards/inwards.service';
import { AlertMessageService } from 'app/core/common/alert.message.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-outward-fees-change-request-result',
    templateUrl: './outward-fees-change-request-result.component.html',
    styleUrls: ['./outward-fees-change-request-result.component.scss'],
})
export class OutwardFeesChangeRequestResultComponent implements OnInit {
    dialogTitle = `Fees Change Request`;
    outwardChangeReqForm: FormGroup;
    checkedStates = {
        feesAmount: false,
        visitCharge: false,
        typingCharge: false
    };
    saveButtonEnabled: boolean = false;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { outward: IOutwardInward; jobNumber: number },
        private _formBuilder: FormBuilder,
        private _matDialogRef: MatDialogRef<OutwardFeesChangeRequestResultComponent>,
        private _inwardsService: InwardsService,
        private _alertMessage: AlertMessageService
    ) {

        this.outwardChangeReqForm = this._formBuilder.group({
            invoiceId: [this.data.outward.invoiceId],
            outwardId: [this.data.outward.id],
            jobNumber: [this.data.jobNumber],
            feesAmount: [''],
            visitCharge: [''],
            typingCharge: [''],
            remark: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        // Subscribe safely with takeUntil
        this.outwardChangeReqForm.valueChanges
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.updateSaveButtonState();
            });
    }

    save(): void {
        const feesChanges = this.outwardChangeReqForm.getRawValue();
        this._inwardsService
            .feesChangeRequest(feesChanges)
            .subscribe((response) => {
                if (response.isSuccess) {
                    this._alertMessage.success('Charges added successfully');
                    this._matDialogRef.close(response);
                } else {
                    this._alertMessage.error(response.errors.join('\n'));
                }
            });
    }

    onClose(): void {
        this._matDialogRef.close();
    }

    onCheckedChange(event: MatCheckboxChange, field: string) {
        this.checkedStates[field] = event.checked;

        const control = this.outwardChangeReqForm.get(field);
        if (event.checked) {
            control.enable();
            control.setValidators([Validators.required]);
        } else {
            control.disable();
            control.reset(); // clear value
            control.setValidators(null);
        }
        control.updateValueAndValidity();
        this.updateSaveButtonState();
    }

    updateSaveButtonState() {
        const anyFeeCheckedAndValid = Object.entries(this.checkedStates).some(([field, checked]) => {
            const control = this.outwardChangeReqForm.get(field);
            return checked && control.valid;
        });

        this.saveButtonEnabled = anyFeeCheckedAndValid && this.outwardChangeReqForm.get('remark').valid;
    }
}
